"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimefilterPayloadForSocket = exports.formatAppNameText = exports.isJsonString = exports.isInViewport = exports.getTransactionMethodId = void 0;
const date_1 = require("./date");
const getTransactionMethodId = (source, operation) => `${source}-${operation}`;
exports.getTransactionMethodId = getTransactionMethodId;
const isInViewport = (el) => {
    if (!el)
        return false;
    const rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
exports.isInViewport = isInViewport;
const isJsonString = (str) => {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.isJsonString = isJsonString;
const formatAppNameText = (text) => {
    return text.replaceAll(".", "").toLowerCase();
};
exports.formatAppNameText = formatAppNameText;
const getTimefilterPayloadForSocket = (hoursRange) => {
    if (hoursRange) {
        const time = new Date().getTime();
        return {
            from: time,
            to: time + hoursRange * date_1.HOUR_IN_MS,
        };
    }
    return undefined;
};
exports.getTimefilterPayloadForSocket = getTimefilterPayloadForSocket;
//# sourceMappingURL=common.js.map